import React from "react";

import styles from "./Logo.module.scss";

export const Logo = React.memo(() => (
  <div className={styles.root}>
    <span className={styles.left}>PET</span><span className={styles.right}>Match</span><sup className={styles.sup}>TM</sup>
  </div>
));
